import React, { useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppBarForm } from './appBar';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../api/authApi';
import { AppDispatch } from '../../../api/store';

export const AppBarContainer: React.FC = () => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  
  const currentParams = new URLSearchParams(location.search);
  const currentLanguage = currentParams.get('lang') || 'en';
  const [language, setLanguage] = useState(currentLanguage);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);

    currentParams.set('lang', selectedLanguage);
    navigate(`${location.pathname}?${currentParams.toString()}`);
  };

  // Handle Logout
  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login'); // Redirect to login page after logout
  };

  return (
    <AppBarForm
      anchorElUser={anchorElUser}
      language={language}
      onOpenUserMenu={handleOpenUserMenu}
      onCloseUserMenu={handleCloseUserMenu}
      onLanguageChange={handleLanguageChange}
      onLogout={handleLogout} // Pass logout function to AppBarForm
    />
  );
};
